var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("td", { staticClass: "col-cell pr-4 py-4 align-top" }, [
    _c(
      "span",
      {
        class: `py-0.5 px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
          _vm.status
            ? "bg-green-100 text-green-800"
            : "bg-yellow-100 text-yellow-800"
        }`,
      },
      [_vm._v(_vm._s(_vm.status ? "Available" : "Booked"))]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }